/* eslint-disable no-nested-ternary */

const arraySorterer = (array, by) => {
  const ordererArray = array.sort((p1, p2) => (p2[by] < p1[by] ? 1 : p2[by] > p1[by] ? -1 : 0));
  return ordererArray;
};

export default arraySorterer;
